<div
    *transloco="let t"
    class="bazis-modal-wrap"
>
    <ng-container
        *ngIf="{
            items: itemsToSign$ | async,
            filesIsUploaded: filesIsUploaded.$ | async,
        } as data"
    >
        @if (currentStep < 4) {
            <div class="bazis-modal__header">
                @if (currentStep === 2 && showCertificatesBlock && pluginError) {
                    <div class="bazis-alert__icon">
                        <bazis-icon
                            name="alert"
                            size="giant"
                            color="danger"
                        ></bazis-icon>
                    </div>
                    <h2>{{ t('crypto.info.title') }}</h2>
                    <p
                        class="bazis-text_secondary bazis-h4"
                        [innerHTML]="t('crypto.info.description')"
                    ></p>
                } @else {
                    <h2>
                        {{ t(data.items.length > 1 ? 'crypto.docsSigning' : 'crypto.docSigning') }}
                    </h2>
                    <p class="bazis-text_secondary bazis-h4">
                        {{ t(data.items.length > 1 ? 'crypto.checkDocs' : 'crypto.checkDoc') }}
                    </p>
                }
            </div>
        }

        <!-- STEP 1-->
        @if (currentStep === 1) {
            <div class="bazis-modal__content">
                @if (filesIsUploaded._ !== data.items.length) {
                    <bazis-default-loader
                        [message]="
                            t(data.items.length > 1 ? 'crypto.loadedDocs' : 'crypto.loadedDoc')
                        "
                        theme="transparent"
                        type="inline"
                        loader="dots"
                    ></bazis-default-loader>
                } @else {
                    <!-- <p class="bh-margin-bottom-3x bazis-p_minor bh-font-medium">
                        @if (data.items.length === 1) {
                            <span> {{ t('crypto.file') }}: </span>
                        } @else {
                            <span> {{ t('crypto.files', { count: data.items.length }) }}: </span>
                        }
                    </p> -->
                }

                <div *ngFor="let item of data.items">
                    <ng-container *ngIf="item.document$ | async as doc">
                        @if (filesIsUploaded._ === data.items.length) {
                            <bazis-document-accordeon [document]="doc"></bazis-document-accordeon>
                        }
                    </ng-container>
                </div>
            </div>

            <div class="bazis-modal__footer">
                <bazis-toolbar>
                    <div
                        slot="end"
                        class="bh-line-elements"
                    >
                        <bazis-button
                            size="large"
                            fill="outline"
                            (click)="close()"
                        >
                            {{ t('action.cancel') }}
                        </bazis-button>
                        <bazis-button
                            size="large"
                            color="action"
                            [disabled]="data.filesIsUploaded !== data.items.length"
                            (click)="currentStep = currentStep + 1"
                        >
                            {{ t('action.okNext') }}
                        </bazis-button>
                    </div>
                </bazis-toolbar>
            </div>
        }

        <!-- STEP 2-->
        @if (currentStep === 2) {
            <div class="bazis-modal__content">
                <!-- <div class="bh-margin-bottom-3x bh-font-medium">
                    @if (data.items.length) {
                        @if (data.items.length === 1) {
                            <span>{{ t('crypto.file') }}</span>
                        } @else {
                            <span>
                                {{
                                    t('crypto.remainToSign', {
                                        remain: remainToSign$ | async,
                                        total: data.items.length,
                                    })
                                }}
                            </span>
                        }
                    }
                </div> -->
                <ul class="bazis-list">
                    @for (item of data.items; track $index) {
                        <li class="bazis-item bh-margin-bottom-4x">
                            <ng-container *ngIf="item.document$ | async as doc">
                                <bazis-link
                                    borderStyle="none"
                                    [href]="doc.$snapshot.file_upload_url"
                                >
                                    <bazis-icon
                                        slot="start"
                                        name="document"
                                    ></bazis-icon>
                                    {{ doc.$snapshot.name }}
                                </bazis-link>
                                <!-- <bazis-file-inline [file]="doc"></bazis-file-inline> -->
                            </ng-container>
                        </li>
                    }
                </ul>

                @if (showCertificatesBlock) {
                    @let certificates = certificates$ | async;
                    @if (!pluginError) {
                        <app-crypto-certificates
                            [(certificate)]="certificate"
                            [certificates$]="certificates$"
                        ></app-crypto-certificates>
                    }
                }
            </div>

            <div class="bazis-modal__footer">
                <bazis-toolbar>
                    <div
                        slot="end"
                        class="bh-line-elements"
                    >
                        <bazis-button
                            size="large"
                            fill="outline"
                            (click)="currentStep = currentStep - 1"
                        >
                            {{ t('action.back') }}
                        </bazis-button>
                        @if (pluginError) {
                            <bazis-button
                                size="large"
                                color="action"
                                href="https://cryptopro.ru/products/csp/downloads"
                                target="_blank"
                            >
                                {{ t('crypto.info.btn') }}
                            </bazis-button>
                        } @else {
                            <bazis-button
                                size="large"
                                color="action"
                                [disabled]="!certificate"
                                (click)="sign()"
                            >
                                {{ t('action.sign') }}
                            </bazis-button>
                        }
                    </div>
                </bazis-toolbar>
            </div>
        }

        <!-- STEP 3-->
        @if (currentStep === 3) {
            <bazis-default-loader
                loader="dots"
                theme="transparent"
                type="inline"
                [message]="t('crypto.signLoading')"
            ></bazis-default-loader>
            <div class="bazis-backdrop bh-hide-sm-up"></div>
        }
        <!-- <div>signed {{ signed | json }}</div>-->
    </ng-container>

    <ng-container
        *ngIf="{
            signEntity: signEntity$ | async,
        } as data"
    ></ng-container>
</div>
